import { hubRoles, type HubPermission } from "@barmetvault/shared";
import {
  PageHeader,
  DataTable,
  ErrorState,
  LoadingState,
  PermissionDenied,
  StatusBadge,
} from "../components/hub/OperationalUI";
import { useHubResource } from "./useHubResource";
export default function PermissionsPage() {
  const result = useHubResource<{
    legacyRoles: string[];
    permissions: HubPermission[];
  }>("/hub/me");
  return (
    <section className="hub-page">
      <PageHeader
        title="Usuarios y permisos"
        subtitle="Transición de roles actuales a permisos granulares por organización."
      />
      {result.state === "denied" ? (
        <PermissionDenied />
      ) : result.state === "error" ? (
        <ErrorState retry={result.retry} />
      ) : !result.data ? (
        <LoadingState />
      ) : (
        <section className="hub-card">
          <h2>Mis permisos efectivos de Hub</h2>
          <p>Roles actuales: {result.data.legacyRoles.join(", ")}</p>
          <DataTable
            rows={result.data.permissions.map((id) => ({ id }))}
            rowKey={(r) => r.id}
            columns={[{ title: "Permiso", render: (r) => r.id }]}
          />
        </section>
      )}
      <section className="hub-card">
        <h2>Roles objetivo</h2>
        <div className="hub-links">
          {hubRoles.map((role) => (
            <StatusBadge key={role} status={role} />
          ))}
        </div>
        <p>
          Los roles objetivo no conceden acceso automáticamente. El modelo
          actual se conserva hasta revisar sus mappings.
        </p>
      </section>
    </section>
  );
}
